{
  "main": {
    "welcome": "Salom {company}!",
    "new_messages": "moshina yo'q | {n} moshin | {n} moshina",
    "appeal": "Мурожаат ёзиш",
    "appeal_content": "Aytadigan narsangiz bormi? Bizning Telegram bot orqali yangilkik yarating!",
    "full_lang": {
      "en": "English",
      "ru": "Русский",
      "uz": "O'zbekcha",
      "uz-to": "Ўзбекча"
    },
    "short_lang": {
      "en": "En",
      "ru": "Ру",
      "uz": "O'z",
      "uz-to": "Ўз"
    },
    "live_stream": "Jonli efir",
    "sum": "so'm",
    "sections": "rubrikalar",
    "all": "hammasi",
    "main": "asosiy",
    "categories": "Categoriyalar",
    "contacts": "Kontaktlar",
    "information": "Ma'lumot",
    "more": "Batafsil",
    "return": "Qaytish",
    "read_also": "Shuningdek o'qing"
  },
  "footer": {
    "disclaimer_text": "Saytdagi yangiliklardan foydalanish uchun yozma rozilik talab qilinadi",
    "founder": "Asoschisi",
    "certificate": "Shaxodatnoma",
    "date_issued": "Berilgan sana"
  },
  "not-found": {
    "not-found": "bunday sahifa mavjud emas yoki o'chirilgan"
  },
  "search_bar": {
    "input_placeholder": "Qidirmoq",
    "result": "So'rov bo'yicha natijalar",
    "result_not_first": "Talab bo'yicha",
    "result_not": "hech narsa topilmadi",
    "sort_new": "Birinchisi yangi",
    "sort_old": "Avval eski",
    "recomend": "Siz uchun tavsiyalar:"
  },
  "months": {
    "january": "Yanvar",
    "february": "Fevral",
    "march": "Mart",
    "april": "Aprel",
    "may": "May",
    "june": "Iyun",
    "july": "Iyul",
    "august": "Avgust",
    "september": "Sentyabr",
    "october": "Oktyabr",
    "november": "Noyabr",
    "december": "Dekabr"
  },
  "days": {
    "today": "Bugun",
    "yesterday": "Kecha",
    "0": "Yakshanba",
    "1": "Dushanba",
    "2": "Seshanba",
    "3": "Chorshanba",
    "4": "Payshanba",
    "5": "Juma",
    "6": "Shanba"
  },
  "video_player": {
    "volume": "Tovush",
    "start_pauza": "Boshlash/pauza",
    "mini_screen": "Mini-pleer",
    "full_screen": "Keng ekran",
    "back": "Qaytish"
  },
  "error": {
    "error": "xato",
    "search": "Sizni qiziqtirgan yangiliklarni topish uchun qidiruvdan foydalanishingiz mumkin",
    "orback": "yoki oldingi sahifaga qayting",
    "input": "Qidirish...",
    "nothing-found": "Hech narsa topilmadi"
  },
  "sayt_test": {
    "saytTest": "Sayt sinov rejimida ishlaydi"
  },
  "routes": {
    "LiveStream": "Jonli efir",
    "404": "Topilmadi",
    "Search": "Qidiruv",
    "SearchQuery": "Qidiruv {query}",
    "NewsDetail": "Zamon yangiliklar",
    "FeedWrapper": "Zamon yangiliklar",
    "MainWrapper": "{category} Zamon yangiliklar",
    "StaffDetail": "Personal Kabinet",
    "AccountSettings": "Accauntni o'zgartirish",
    "CreateArticles": "Yangilik yaratish",
    "EditArticle": "Yangilikni o'zgartirish",
    "PreferredLang": "Yangilik yaratish",
    "Articles": "Yangiliklar",
    "StaffPage": "Zamon jamoasi",
    "LogIn": "Kirish",
    "Registration": "Ro'yxatdan o'tish",
    "Recovery": "Parol tiklash"
  },
  "authorization": {
    "enter": "Kirish",
    "registration": "Ro'yxatdan o'tish",
    "login": "Login",
    "password": "Parol",
    "wronglogin": "* Noto'g'ri login",
    "wrongpassword": "* Noto'g'ri parol",
    "forogtPassword": "Parol unutdingizmi?",
    "mainPage": "Asosiy saxifaga qaytish",
    "name": "Ism",
    "surname": "Familiya",
    "phone": "Telefon nomer",
    "email": "elektron pochta",
    "continue": "Davom ettirish",
    "realName": "Xaqiqiy ismingizni kiriting",
    "realsurname": "Xaqiqiy familitangizni kiriting",
    "enterPhone": "Telefon nomer kiriting",
    "entermail": "elektron pochta kiriting",
    "emptyArea": "*Ushbu qator to'ldirilishi shart",
    "newPassword": "Parol o'ylab toping",
    "createNewPassword": "Yangi parol bilan keling",
    "replyNewPassword": "Parolni qayta kiriting",
    "back": "Orqaga",
    "needLogin": "Kirish uchun sizga login kerak bo'ladi",
    "passwordLength": "Parol kamida oltita raqam, harf va tinish belgilaridan iborat bo'lishi kerak",
    "showPassword": "*Parol juda qisqa",
    "passwordMismatch": "*Parollar mos kelmayapti",
    "busyLogin": "*Login «Onegin» band",
    "infPassport": "Passport rasmini qo'shing",
    "contentPassport": "*Rasm sifatli bo'lishi kerak,passportda porloq va soyasiz,yaxshi o'qilgan ma'lumotlar bo'lishi kerak",
    "completeRegister": "Ro'yxatdan o'tish tugallandi",
    "getImage": "Rasmni torting",
    "selectImage": "Tanlash...",
    "imageFormat": "JPG, PNG",
    "image": "Rasm",
    "message": "Tekshiruvdan o'tgan sp'ng,biz sizning elektron pochtangizga shaxsiy hisobingizni kirish uchun xavola yuboramiz",
    "validation": "Tasdiqlash  1 dan 3 ish kunigacha davom etadi",
    "clear": "Tushunarli",
    "resetPassword": "parolni qayta o'rnating",
    "passwordRecovery": "Parolni tiklash",
    "mailMessage": "Quyida elektron pochta manzilingizni kiriting va biz sizga yangi parolni yaratish bo'yicha ko'rsatmalarni o'z ichiga olgan elektron pochta xabarini yuboramiz.",
    "yourMail": "Sizning elektron manzilingiz",
    "resetEmail": "*Ro'yxatdan o'tish paytida ko'rsatilgan elektron pochta manzilini kiriting",
    "instruction": "Sizning pochtangizga yangi parolni yaratish bo'yicha ko'rsatmalar yuborilgan elektron pochta yuborildi",
    "saveChanges": "O'zgarishlarni saqlang",
    "verifyTitle": "Tasdiqlash kodi ro'yxatdan o'tish paytida siz ko'rsatgan raqamga SMS orqali yuborilgan",
    "verification_code_invalid": "Noto'g'ri tasdiqlash kodi",
    "confirmCode": "Tasdiqlash kodi",
    "repeatCode": "Kodni qayta yuborish",
    "confirmCodeBtn": "Kodni tasdiqlash",
    "humanPassportTitle": "Rasmda ko'rsatilgandek ochiq pasportli rasm qo'shing →",
    "explanation": "*Surat sifatli bo'lishi kerak. Quyosh ko'zoynakli fotosuratlarga ruxsat berilmaydi, yuz yaxshi yoritilgan bo'lishi kerak",
    "overlay": "To'liq ro'yxatga olish"
  },
  "world": {
    "world_population": "Dunyo aholisi"
  },
  "staff_page": {
    "count_news": "Xabarlar",
    "count_views": "Ko'rishlar",
    "about_me": "O'zim haqimda",
    "last_news": "Oxirgi maqolalar:",
    "journalists": "Jurnalistlar",
    "employees": "Xodimlar",
    "news_card": {
      "title": "В Ташкенте прошёл ежегодный фестиваль электронной музыки",
      "data": "08.05.2021, 22:57",
      "category": "Подкатегория"
    }
  },
  "header": {
    "new_news": "Yangiliklar yaratish",
    "auth": "Avtorizatsiya",
    "appeal": "Apellyatsiya yozing"
  },
  "news__detail": {
    "share": "share link",
    "share_facebook": "share on facebook",
    "share_instagram": "share on instagram",
    "share_twitter": "share on twitter",
    "share_telegram": "share on telegram",
    "share_title": "share:",
    "tags_title": "tags:"
  },
  "sport": {
    "math_started": "Match boshlandi"
  },
  "time": {
    "hour_ago": "soat",
    "minute_ago": "daqiqa",
    "ago": "oldin"
  },
  "uzbekistan": {
    "selectCountry": "So'nggi yangiliklarni ko'rish uchun mintaqani tanlang:",
    "close": "  Yopish",
    "karakalpakistan": "Qoraqalpog'iston Respublikasi",
    "khorezm": "Xorazm viloyati",
    "navoi": "Navoiy viloyati",
    "bukhara": "Buxoro viloyati",
    "samarkand": "Samarqand viloyati",
    "karshi": "Qashqadaryo viloyati",
    "jizzax": "Jizzax viloyati",
    "surkhandarya": "Surxondaryo viloyati",
    "sirdarya": "Sirdaryo viloyati",
    "tashkent": "Toshkent",
    "namangan": "Namangan viloyati",
    "fergana": "Farg'ona viloyati",
    "andijan": "Andijon viloyati"
  },
  "admin": {
    "admin": "Admin",
    "profile": "Profilni tahrirlash",
    "changepassword": "Parolni o'zgartirish",
    "changed_profile": "muvaffaqiyatli o'zgarish",
    "return": "Qaytish",
    "username": "Ism",
    "surname": "Familiya",
    "userlogin": "Kirish",
    "usermail": "elektron pochta",
    "userbio": "O'zim haqimda",
    "infbio": "O'zingiz haqingizda ma'lumot qo'shing",
    "maxwords": "* Maksimal 150 ta belgidan iborat",
    "apply": "Qo'llash",
    "currentpassword": "Eski parolingizni kiriting",
    "userpassword": "Yangi parolni kiriting",
    "replypassword": "yangi parolni takrorlang",
    "length": "Parol kamida sakkizta raqam, harf va tinish belgilaridan iborat bo'lishi kerak",
    "video": "Ushbu qatorni to'ldirilishi shart",
    "repeatable_fields": "Mundarija va pastki kategoriya mavjud",
    "title": "Yangilik yaratish",
    "changeLang": "* Yangilikni oʻzbek tilida chop etish uchun uni ichiga yozish kerak ikkita versiya - lotin va kirill alifbolarida",
    "prevLang": "Yangilikni",
    "lang": "tilda yaratish",
    "latinlang": "Maydonlarni",
    "latinlangOne": "to'ldiring",
    "latin": "lotinda",
    "kr": "кирилда",
    "comment": "Quyidagi xatolarni tuzating",
    "contentTitle": "Mundarija:",
    "brief": "Qisqacha:",
    "description": "Tavsifi",
    "media": "Video material:",
    "image": "Chizma:",
    "atMoment": "Hozirgi paytda:",
    "selectFile": "faylni tanlang",
    "delete": "o'chirish",
    "tags": "Teglar:",
    "avialable": "Mavjud teglar",
    "selected": "Tanlangan teglar",
    "country": "Mamlakatni tanlang",
    "regions": "Viloyatni tanlang",
    "selectedRegions": "Tanlangan viloyat",
    "selectedCountry": "Tanlangan mamlakat",
    "regions_selected": "Kamida bitta viloyatni tegini tanlang",
    "country_selected": "Kamida bitta mamlakat tegini tanlang",
    "search": "Qidirmoq",
    "filter": "Filtr",
    "commandControl": "Bir nechta qiymatlarni tanlash uchun Control (yoki Mac-dagi buyruq) tugmasini bosib turing.",
    "selectAll": "Hammasini tanlang",
    "removeAll": "Hammasini o'chirish",
    "newsCategory": "Yangiliklar toifasi:",
    "status": "Yangiliklar holati:",
    "draft": "Qoralama",
    "date": "Nashr qilingan sana:",
    "explanationDate": "Yangilik e'lon qilinadigan sana va vaqt",
    "editing": "Saqlang va tahrirlashni davom eting",
    "save": "Saqlash",
    "addedNews": "Yangilik qo'shildi",
    "views": "Umumiy ko'rganlar soni",
    "add_news": "Yangilik qo'shing",
    "go_out": "Saytdan chiqish",
    "home": "Yangiliklarga",
    "changeIMage": "Rasmni o'zagartirish",
    "published_news": "E'lon qilingan yangiliklar",
    "moderation": "Moderatsiya kutilmoqda",
    "rejected": "Rad etilgan yangiliklar",
    "drafts": "Qoralamalar",
    "redactor": "Tahrirlash",
    "Go_to": "Yangilikga o'tish",
    "change_language": "Tilni o'zgartitish",
    "in_en": "Ingliz tilida",
    "in_ru": "Rus tilida",
    "in_uz": "Uzbek tilida",
    "choose_lang": "Qaysi tilda yangiliklar kiritishingizni tanlang",
    "success_msg": "Yangilik moderatsiyaga muvaffaqiyatli yuborildi",
    "not_published": "Sizda tanlangan tilda nashr etilgan yangiliklar yoʻq",
    "mediaToTg": "Telegramdagi media",
    "msgToTg": "Telegramdagi xabar",
    "videoToTg": "Telegramdagi video"
  },
  "super_user": {
    "title": "O'zgartirish uchun yangiliklarni tanlang",
    "set_page": "ga boring",
    "news_count": "Yangiliklar",
    "search": "Toping",
    "filter": "Filtr",
    "id": "ID",
    "news_title": "MUNDARIJA",
    "news_author": "YANGILIKLAR MUALLIFI",
    "news_category": "YANGILIKLAR KATEGORIYASI",
    "news_date": "NASHR ETILGAN SANA",
    "news_status": "YANGILIKLARI STATUSI",
    "draft": "QORALAMA",
    "move": "ko'rsatilgan",
    "from": "dan",
    "clear": "barcha filtrlarni tozalang",
    "from_date": "sanasidan boshlab",
    "to_date": "Sana bo'yicha",
    "reset": "qayta o'rnatish",
    "all": "Hammasi",
    "yes": "Xa",
    "no": "Yo'q"
  }
}